import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../../images/pb_pay_logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const SiteHeader = () => {
  const navigate = useNavigate();

  // const handleLogout = async () => {
  //   try {
  //     let response;
  //     // setIsAuthenticated(false);
  //     // Clear localStorage
  //     localStorage.clear();
  //     setIsAuthenticated(false);
  //     // Update auth state

  //     // Redirect to login page
  //     navigate('/login');
  //     // ===== REAL API INTEGRATION =====
  //     // FOR REAL API: Uncomment this block and comment out MOCK block above

  //     response = await axios.delete(
  //       `${process.env.REACT_APP_API_ENDPOINT}/auth/logout`,
  //       {
  //         withCredentials: true,
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       }
  //     );

  //     const { status, statusCode, data, message, errorCode } = response.data;
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  return (
    <Header>
      <div className="wrapper">
        <div className="header-container">
          <Logo className="logo" alt="logo" />
          <div className="right-header">
            <Link
              to={process.env.REACT_APP_GRIEVANCE_API_ENDPOINT}
              target="_blank"
            >
              <button className="need-help-btn" style={{ cursor: 'pointer' }}>
                <span>
                  <FontAwesomeIcon icon={faPhone} /> Need Help?{' '}
                </span>

                <Link
                  to={process.env.REACT_APP_GRIEVANCE_API_ENDPOINT}
                  target="_blank"
                >
                  Contact Us
                </Link>
              </button>
            </Link>
            {/* {isAuthenticated && (
              <button
                className="need-help-btn"
                style={{ marginLeft: '10px', cursor: 'pointer' }}
                onClick={handleLogout}
              >
                Log Out
              </button>
            )} */}
          </div>
        </div>
      </div>
    </Header>
  );
};

const Header = styled.header`
  // Sum of both paddings+ image height

  padding-top: 24px;
  padding-bottom: 27px;
  // padding: 20px 0;
  .logo {
    height: 50px;
    width: auto;
  }
  @media all and (max-width: 768px) {
    padding-top: 14px;
    padding-bottom: 32px;
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0 14px;
    padding: 0;
  }

  button {
    &.need-help-btn {
      border: none;
      padding: 6px 16px 6px 12px;
      border-radius: 100px;
      background: rgba(23, 43, 77, 0.12);
      // cursor: pointer;
      color: #253858;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      letter-spacing: 0.196px;
      text-align: center;

      a {
        text-decoration: none;
        color: #0065ff;
      }
    }
  }
`;

export default SiteHeader;
